





































































import Vue from 'vue'
import ModalOverlay from '@/common/components/ModalOverlay.vue'
import StockLibraryEmpty from '@/common/components/StockLibrary/StockLibraryEmpty.vue'
import StockLibraryDesignList from '@/common/components/StockLibrary/StockLibraryDesignList.vue'

import { designImagesModal_userDesigns as UserDesign } from '@/common/queries/types/designImagesModal'
import { getUserDesigns } from '@/common/service'

export default Vue.extend({
  components: {
    ModalOverlay,
    StockLibraryEmpty,
    StockLibraryDesignList
  },
  props: {
    headerTitle: {
      type: String,
      default: '使用する画像を選んでください'
    },
    autoFetchDesigns: {
      type: Boolean,
      default: false
    },
    stockLibraryDesigns: {
      type: Array as () => UserDesign[],
      default: () => []
    },
    selectedDesignId: {
      type: String,
      default: null
    },
    showDefault: {
      type: Boolean,
      default: false
    },
    showAddDesign: {
      type: Boolean,
      default: false
    },
    showRemoveDesign: {
      type: Boolean,
      default: false
    },
    showExtension: {
      type: Boolean,
      default: false
    }
  },
  data(): {
    selectedDesign: UserDesign | null | undefined
    switchPosition: boolean
    selfFetchedDesigns: UserDesign[]
    isLoading: boolean
  } {
    return {
      selectedDesign: null,
      switchPosition: false,
      selfFetchedDesigns: [],
      isLoading: false
    }
  },
  computed: {
    userDesigns(): UserDesign[] {
      return this.autoFetchDesigns ? this.selfFetchedDesigns : this.stockLibraryDesigns
    }
  },
  async mounted() {
    if (this.autoFetchDesigns && this.stockLibraryDesigns.length === 0) {
      this.isLoading = true
      const { userDesigns } = await getUserDesigns().finally(() => {
        this.isLoading = false
      })
      this.selfFetchedDesigns = userDesigns
    }
  },
  methods: {
    onCloseModal() {
      this.$emit('close')
    },
    selectDesign(payload: { design: UserDesign, switchPosition: boolean }) {
      this.selectedDesign = payload.design
      this.switchPosition = payload.switchPosition
    },
    confirmSelectDesign() {
      if (!this.selectedDesign) return
      this.$emit(
        'confirmSelectDesign',
        { design: this.selectedDesign, switchPosition: this.switchPosition }
      )
    },
    removeDesign(removedDesignUuid: string) {
      this.$emit('removeDesign', removedDesignUuid)
    },
    showAddNewDesignModal() {
      this.$emit('showAddNewDesignModal')
    }
  }
})
